import { render, staticRenderFns } from "./SaveTransaction.vue?vue&type=template&id=e4fa1a74"
import script from "./SaveTransaction.vue?vue&type=script&lang=js"
export * from "./SaveTransaction.vue?vue&type=script&lang=js"
import style0 from "./SaveTransaction.vue?vue&type=style&index=0&id=e4fa1a74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports